import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const getReviewId = (review, index) => {
  if (typeof review === 'object' && review?.review_id) return review.review_id;
  return `review-${index}`;
};

const getReviewText = (review) => {
  if (typeof review === 'string') return review;
  return review?.text || review?.content || '';
};

export default function SelectableReviewsList({
  reviews = [],
  selectedReviewIds = [],
  onToggle,
  emptyMessage = 'No reviews available.',
}) {
  if (!reviews.length) {
    return <p className="text-sm text-muted-foreground">{emptyMessage}</p>;
  }

  return (
    <div className="space-y-3">
      {reviews.map((review, index) => {
        const reviewId = getReviewId(review, index);
        const isSelected = selectedReviewIds.includes(reviewId);
        const rating = typeof review === 'object' ? review.rating : null;
        const author = typeof review === 'object' ? review.author : null;

        return (
          <div
            key={reviewId}
            className={cn(
              'cursor-pointer rounded-xl border bg-white p-4 shadow-sm transition-all',
              isSelected
                ? 'border-teal ring-1 ring-teal/20'
                : 'border-border/50 hover:border-border',
            )}
            onClick={() => onToggle?.(reviewId)}
          >
            <div className="flex gap-3">
              <div className="mt-0.5 shrink-0">
                <div className={cn(
                  'flex h-5 w-5 items-center justify-center rounded-full border-2 transition-colors',
                  isSelected ? 'border-teal bg-teal text-white' : 'border-muted-foreground/30',
                )}>
                  {isSelected ? <CheckCircle2 className="h-3 w-3" /> : null}
                </div>
              </div>
              <div>
                <p className="text-sm font-medium leading-relaxed text-foreground">
                  "{getReviewText(review)}"
                </p>
                {rating ? (
                  <div className="mt-1.5 flex items-center gap-1">
                    <span className="text-xs tracking-widest text-amber-500">
                      {'★'.repeat(rating)}
                    </span>
                    {author ? <span className="ml-2 text-xs text-muted-foreground">— {author}</span> : null}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
